import React from 'react';

export default function Contact() {
  const lessOperator = "<";
  const greatOperator = ">";
  return (
    <main className="contact">
      <section className="contact_header">
        <h1>
          <span>{lessOperator}</span> Contact <span>{greatOperator}</span>
        </h1>
      </section>
      <section className="form">
        <form
          name="contact"
          netlify
          method="post"
        >
          <input type="hidden" name="form-name" value="contact" />
          <label htmlFor="name">Name</label>
          <input
            type="text"
            name="name"
            id="name"
            minLength="4"
            maxLength="20"
            required
          />
          <label htmlFor="email">Email</label>
          <input type="email" name="email" id="email" required />
          <label htmlFor="subject">Subject</label>
          <input
            type="text"
            name="subject"
            id="subject"
            maxLength="25"
            minLength="2"
          />
          <label htmlFor="description">Description</label>
          <textarea name="description" id="description" />
          <button
            type="submit"
          // onMouseEnter={() => this.props.runOnEnter()}
          // onMouseLeave={() => {
          //   this.props.runOnLeave();
          // }}
          >
            Send
          </button>
        </form>
      </section>
    </main>
  );
}
